import OrganizationEditPage from "@/features/organization/pages/OrganizationEdit";

const OrganizationEdit = () => {
  return <OrganizationEditPage />;
};

export default OrganizationEdit;
